'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var React = require('react');
var lodash = require('lodash');
var useMergedRefs = require('./useMergedRefs-b6d2f8fc.js');
var nanoid = require('nanoid');
require('./Alert-13b75102.js');
require('./Badge-757b0a39.js');
require('./Popover-569cd272.js');
require('./Tab-f499ecbc.js');
require('./Tabs-a8c77f71.js');
var Tooltip = require('./Tooltip-66daf6e3.js');
require('./VerificationStatusIcon-d5bfb67a.js');
var editNote = require('./edit-note-c47d292e.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47;
var fadeInCheck = styled.keyframes(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  from {\n    opacity: 0\n  }\n  to {\n    opacity: 1\n  }\n"])));
var fadeOutCheck = styled.keyframes(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n  from {\n    opacity: 1\n  }\n  to {\n    opacity: 0\n  }\n"])));
var activeLabel = styled.css(_templateObject3 || (_templateObject3 = defaultTheme._taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  padding: 0 3px;\n  top: -7px;\n  letter-spacing: 0.03em;\n  left: 8px !important;\n  opacity: 1 !important;\n"])));
var placeholderBaseStyle = styled.css(_templateObject4 || (_templateObject4 = defaultTheme._taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('gray-600'));
}, function (props) {
  return props.theme.themeProp('opacity', 0.6, 0.5);
});
var TextAreaContainter = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject5 || (_templateObject5 = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n"])));
var Label = styled__default['default'].label.attrs(defaultTheme.applyDefaultTheme)(_templateObject6 || (_templateObject6 = defaultTheme._taggedTemplateLiteral(["\n  ", ";\n  flex-basis: 33.33%;\n  font-size: 0.875rem;\n  line-height: 1rem;\n  height: 19px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 13px;\n  ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('white'), props.theme.getColor('gray-700'));
}, function (props) {
  return props.disabled && styled.css(_templateObject7 || (_templateObject7 = defaultTheme._taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "])));
});
var InputIconContainer = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject8 || (_templateObject8 = defaultTheme._taggedTemplateLiteral(["\n  opacity: 0;\n  pointer-events: none;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  display: flex;\n  align-items: flex-start;\n\n  position: absolute;\n  right: 15px;\n  top: 10px;\n  bottom: 0;\n  > .smallPadingIcon {\n    padding: 4px;\n    width: 15px;\n    height: 15px;\n    border-radius: 5px;\n    opacity: 1;\n    margin-top: -5px;\n    ", "\n  }\n  svg {\n    width: 15px;\n    opacity: 0.7;\n    transition: opacity 250ms;\n\n    ", "\n  }\n"])), function (props) {
  return props.theme.themeProp('background-color', props.theme.getColor('gray-900'), props.theme.getColor('gray-300'), '!important');
}, function (props) {
  return props.disabled && styled.css(_templateObject9 || (_templateObject9 = defaultTheme._taggedTemplateLiteral(["\n        display: none;\n      "])));
});
var TextInputField = styled__default['default'].textarea.attrs(defaultTheme.applyDefaultTheme)(_templateObject10 || (_templateObject10 = defaultTheme._taggedTemplateLiteral(["\n  width: 100%;\n  font-family: inherit;\n  font-size: 0.875rem;\n  border-radius: 2px;\n  padding: 5px 10px;\n  resize: vertical;\n  z-index: 0;\n  border-radius: 3px;\n  box-sizing: border-box;\n  appearance: none;\n  border: 1px solid;\n\n \n\n   ", "\n\n \n \n\n    transition: height 550ms ease-in-out; border-color 350ms;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  \n\n \n  ", "\n\n   ", "\n     \n  ", "\n\n  ", "\n\n  ", " \n\n  ", "  \n  \n\n  ", "   \n\n     \n    \n  ", "\n\n      ", "       \n\n  ", "\n    \n  \n    ", "\n\n  ", "\n\n\n  ", ";\n\n  ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n      ", "\n\n\n\n  &&:hover:not(:focus) {\n    ", ";\n\n      ", ";\n\n    ", ";\n\n  \n     ", "; \n\n\n    ", ";\n    transition: background 350ms;\n    & + ", " {\n      opacity: 1;\n      ", ";\n      transition: opacity 350ms;\n    }\n  }\n\n  &::placeholder {\n    ", "\n\n    ", "\n  }\n\n  &&:focus {\n    outline: none;\n    ", "\n\n    ", ";\n\n        \n    ", "  \n      \n    ", "\n\n  }\n\n  &&:not(:hover):not(:focus) {\n    ", ";\n    ", ";\n\n       ", "\n\n    ", ";\n\n       \n  }\n"])), function (props) {
  return props.borderRadius && styled.css(_templateObject11 || (_templateObject11 = defaultTheme._taggedTemplateLiteral(["\n       border-radius: ", "px;\n     "])), props.borderRadius);
}, function (props) {
  return props.theme.themeProp('color', 'white', 'black');
}, function (props) {
  return props.readOnly && styled.css(_templateObject12 || (_templateObject12 = defaultTheme._taggedTemplateLiteral(["\n      cursor: default;\n      border-color: transparent !important;\n    "])));
}, function (props) {
  return props.disabled && styled.css(_templateObject13 || (_templateObject13 = defaultTheme._taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "])));
}, function (props) {
  return props.readOnly && styled.css(_templateObject14 || (_templateObject14 = defaultTheme._taggedTemplateLiteral(["\n      padding: 12px 10px; ;\n    "])));
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-100'), props.theme.getColor('gray-900'));
}, function (props) {
  return (props.state === 'warning' || props.state === 'error') && props.theme.themeProp('color', props.theme.getColor('gray-900'), props.theme.getColor('gray-900'));
}, function (props) {
  return props.theme.themeProp('background', props.theme.getColor('gray-900'), props.theme.getColor('white'));
}, function (props) {
  return props.theme.themeProp('border-color', props.theme.getColor('gray-500'), props.theme.getColor('gray-400'));
}, function (props) {
  return props.noBorder && styled.css(_templateObject15 || (_templateObject15 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n    "])), function (props) {
    return props.theme.themeProp('border-color', props.theme.getColor('gray-900'), props.theme.getColor('white'));
  });
}, function (props) {
  return props.type === 'warning' && styled.css(_templateObject16 || (_templateObject16 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n      ", "\n      ", "\n    "])), props.theme.themeProp('color', '#EAB308', 'black'), props.theme.themeProp('background', '#2F2402', '#F2D16B'), props.theme.themeProp('border-color', '#2F2402 ', '#F2D16B'));
}, function (props) {
  return props.type === 'error' && styled.css(_templateObject17 || (_templateObject17 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n      ", "\n      ", "\n    "])), props.theme.themeProp('color', 'white', 'black'), props.theme.themeProp('background', '#7f1b1b', '#FBEAE6'), props.theme.themeProp('border-color', '#7f1b1b', '#FBEAE6'));
}, function (props) {
  return props.noBorder && props.type === 'warning' && styled.css(_templateObject18 || (_templateObject18 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n    "])), function (props) {
    return props.theme.themeProp('border-color', '#2F2402', '#F2D16B');
  });
}, function (props) {
  return props.noBorder && props.type === 'error' && styled.css(_templateObject19 || (_templateObject19 = defaultTheme._taggedTemplateLiteral(["\n          ", "\n        "])), function (props) {
    return props.theme.themeProp('border-color', '#7f1b1b', '#FBEAE6');
  });
}, function (props) {
  return props.type === 'warning-border' && styled.css(_templateObject20 || (_templateObject20 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n    "])), props.theme.themeProp('border-color', props.theme.getColor('red-200'), props.theme.getColor('orange-500')));
}, function (props) {
  return props.type === 'error-border' && styled.css(_templateObject21 || (_templateObject21 = defaultTheme._taggedTemplateLiteral(["\n        ", "\n      "])), props.theme.themeProp('border-color', props.theme.getColor('red-200'), props.theme.getColor('red-500')));
}, function (props) {
  return props.lightBackground && styled.css(_templateObject22 || (_templateObject22 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n      ", "\n          &&:hover {\n        ", "\n      }\n    "])), props.theme.themeProp('background', '#FFFDDE', '#fffde8'), props.theme.themeProp('color', props.theme.getColor('gray-900'), props.theme.getColor('gray-900')), props.theme.themeProp('background', 'white', 'white'));
}, function (props) {
  return props.edit && props.type != 'warning' && props.theme.themeProp('background', '#505050', '#eff1f4');
}, function (props) {
  return props.edit && props.type === 'warning' && props.theme.themeProp('background', '#AD8800', '#FFF3A7');
}, function (props) {
  return props.padding === 'small' && styled.css(_templateObject23 || (_templateObject23 = defaultTheme._taggedTemplateLiteral(["\n      padding: 5px 10px;\n    "])));
}, function (props) {
  return props.padding === 'medium' && styled.css(_templateObject24 || (_templateObject24 = defaultTheme._taggedTemplateLiteral(["\n      padding: 13px 15px;\n    "])));
}, function (props) {
  return props.padding === 'large' && styled.css(_templateObject25 || (_templateObject25 = defaultTheme._taggedTemplateLiteral(["\n      padding: 15px 55px;\n    "])));
}, function (props) {
  return props.hasIcon && styled.css(_templateObject26 || (_templateObject26 = defaultTheme._taggedTemplateLiteral(["\n          padding-left: 55px;\n          padding-right: 35px;\n          padding-top: 13.5px;\n        "])));
}, function (props) {
  return !props.readOnly && !props.disabled && props.theme.themeProp('background', props.theme.getColor('gray-700'), props.theme.getColor('gray-100'));
}, function (props) {
  return props.edit && props.theme.themeProp('border-color', props.theme.getColor('gray-700'), props.theme.getColor('gray-100'));
}, function (props) {
  return props.type === 'warning' && props.theme.themeProp('background', '#806403', '#FFDB70');
}, function (props) {
  return props.type === 'error' && props.theme.themeProp('background', '#F7D5D0', '#F7D5D0');
}, function (props) {
  return props.noBorder && !props.readOnly && props.type != 'warning' && props.type != 'error' ? props.theme.themeProp('background', props.theme.getColor('gray-700'), props.theme.getColor('gray-100')) : 'background: transparent';
}, InputIconContainer, function (props) {
  return props.type === 'success' && styled.css(_templateObject27 || (_templateObject27 = defaultTheme._taggedTemplateLiteral(["\n          opacity: 0;\n        "])));
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('gray-600'), 1);
}, function (props) {
  return props.theme.themeProp('opacity', 0.6, 0.5, 1);
}, function (props) {
  return props.theme.themeProp('border-color', props.theme.getColor('gray-500'), props.theme.getColor('gray-600'));
}, function (props) {
  return props.theme.themeProp('background', props.theme.getColor('gray-700'), props.theme.getColor('white'));
}, function (props) {
  return props.type === 'warning' && styled.css(_templateObject28 || (_templateObject28 = defaultTheme._taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n      "])), function (props) {
    return props.theme.themeProp('border-color', '#F4E21E', '#F4E21E');
  }, props.theme.themeProp('background', 'white', 'white'), props.theme.themeProp('color', 'black', 'black'));
}, function (props) {
  return props.type === 'error' && styled.css(_templateObject29 || (_templateObject29 = defaultTheme._taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n      "])), function (props) {
    return props.theme.themeProp('border-color', '#D83018', '#D83018');
  }, props.theme.themeProp('background', 'white', 'white'), props.theme.themeProp('color', 'black', 'black'));
}, function (props) {
  return props.edit && props.theme.themeProp('background', 'rgba(39,39,42, 0.7)', 'rgba(244,244,245, 0.3)');
}, function (props) {
  return props.edit && props.theme.themeProp('border-color', 'rgba(39,39,42, 0.7)', 'rgba(228,228,231, 0.3)');
}, function (props) {
  return props.noBorder && props.edit && styled.css(_templateObject30 || (_templateObject30 = defaultTheme._taggedTemplateLiteral(["\n           ", "\n         "])), function (props) {
    return props.theme.themeProp('border-color', '#27272A', 'rgba(244,244,245, 0.3)');
  });
}, function (props) {
  return props.edit && props.type === 'warning' && props.theme.themeProp('background', '#2F2402', '#FFF3A7');
});
var TextInputLabel = styled__default['default'].label.attrs(defaultTheme.applyDefaultTheme)(_templateObject31 || (_templateObject31 = defaultTheme._taggedTemplateLiteral(["\n  position: absolute;\n  top: 13px;\n  left: 11px;\n  line-height: 1.2;\n  font-size: 0.875rem;\n  transition: all 150ms;\n  margin-botton: 50px;\n\n  ", ";\n\n  ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n  content: \"\";\n\n  ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('white'), props.theme.getColor('gray-700'));
}, placeholderBaseStyle, function (props) {
  return props.theme.themeProp('background', "linear-gradient(0deg, ".concat(props.theme.getColor('gray-900'), " calc(50% + 1px), transparent 50%)"), "linear-gradient(0deg, ".concat(props.theme.getColor('white'), " calc(50% + 1px), transparent 50%)"));
}, function (props) {
  return !props.inputIsEmpty && styled.css(_templateObject32 || (_templateObject32 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n    "])), activeLabel);
}, function (props) {
  return props.hasPlaceholder && styled.css(_templateObject33 || (_templateObject33 = defaultTheme._taggedTemplateLiteral(["\n      ", ";\n    "])), activeLabel);
}, function (props) {
  return props.hasIcon && styled.css(_templateObject34 || (_templateObject34 = defaultTheme._taggedTemplateLiteral(["\n      left: 55px;\n    "])));
});
var TextInputFieldIcon = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject35 || (_templateObject35 = defaultTheme._taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 2.625rem;\n  display: flex;\n  padding: 0 10px;\n\n  svg {\n    width: 15px;\n    opacity: 0.6;\n    transition: opacity 250ms;\n  }\n"])));
var TextInputFieldIconAlert = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject36 || (_templateObject36 = defaultTheme._taggedTemplateLiteral(["\n  position: absolute;\n  top: 2.8px;\n  display: flex;\n  padding: 0 10px 0 30px;\n  opacity: 0.6;\n  transition: opacity 250ms;\n  ", "\n  svg {\n    margin-top: 12px;\n    width: 15px;\n  }\n"])), function (props) {
  return props.type === 'warning' && props.theme.themeProp('color', '#EAB308', '#2F2402');
});
var TextInput = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject37 || (_templateObject37 = defaultTheme._taggedTemplateLiteral(["\n  position: relative;\n  flex-basis: ", ";\n\n  ", "\n\n  ", "\n\n  &:focus-within {\n    ", " {\n      ", ";\n    }\n\n    ", " {\n      svg {\n        opacity: 1;\n      }\n    }\n  }\n\n  ", ":not(:placeholder-shown) + ", " {\n    ", ";\n    ", "\n  }\n  }\n"])), function (props) {
  return props.$fieldLabel ? '66.66%' : '100%';
}, function (props) {
  return props.readOnly && styled.css(_templateObject38 || (_templateObject38 = defaultTheme._taggedTemplateLiteral(["\n      pointer-events: none;\n    "])));
}, function (props) {
  return props.disabled && styled.css(_templateObject39 || (_templateObject39 = defaultTheme._taggedTemplateLiteral(["\n      opacity: 0.5;\n\n      > * {\n        cursor: not-allowed;\n      }\n    "])));
}, TextInputLabel, activeLabel, TextInputFieldIcon, TextInputField, TextInputLabel, activeLabel, function (props) {
  return props.type === 'error' && props.theme.themeProp('color', props.theme.getColor('red-200'), props.theme.getColor('red-500'));
});
var Description = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject40 || (_templateObject40 = defaultTheme._taggedTemplateLiteral(["\n  margin: 8px 0 0 0;\n  padding: 0 0.6875rem;\n  font-size: 0.75rem;\n  line-height: 1.333;\n\n  ", ";\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-400'), props.theme.getColor('gray-500'));
}, function (props) {
  return (props.type === 'warning-border' || props.type === 'warning') && styled.css(_templateObject41 || (_templateObject41 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n    "])), props.theme.themeProp('color', props.theme.getColor('red-200'), props.theme.getColor('orange-500')));
}, function (props) {
  return (props.type === 'error-border' || props.type === 'error') && styled.css(_templateObject42 || (_templateObject42 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n    "])), props.theme.themeProp('color', props.theme.getColor('red-200'), props.theme.getColor('red-500')));
});
var SuccessContainer = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject43 || (_templateObject43 = defaultTheme._taggedTemplateLiteral(["\n  opacity: 1;\n  pointer-events: none;\n  opacity: ", ";\n  animation: ", " 0.5s ease-in-out;\n  transition: opacity 0.5s ease-in-out;\n  position: absolute;\n  margin-top: -35px;\n  margin-left: 5px;\n  width: 15px;\n  height: 15px;\n  padding: 5px;\n  ", "\n\n  > svg {\n    width: 15px;\n  }\n"])), function (props) {
  return props.fadeIn ? 0 : 1;
}, function (props) {
  return props.fadeIn ? fadeOutCheck : fadeInCheck;
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('gray-500'));
});
var SuccessContainerLabel = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject44 || (_templateObject44 = defaultTheme._taggedTemplateLiteral(["\n  opacity: 1;\n  pointer-events: none;\n  opacity: ", ";\n  animation: ", " 0.5s ease-in-out;\n  transition: opacity 0.5s ease-in-out;\n  margin-right: 5px;\n  margin-top: -7px;\n  width: 15px;\n  height: 15px;\n  padding: 5px;\n  ", "\n\n  > svg {\n    width: 13px;\n  }\n"])), function (props) {
  return props.fadeIn ? 0 : 1;
}, function (props) {
  return props.fadeIn ? fadeOutCheck : fadeInCheck;
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('gray-500'));
});
styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject45 || (_templateObject45 = defaultTheme._taggedTemplateLiteral(["\n  margin-top: -18px;\n  margin-bottom: 0;\n  display: block;\n  position: absolute;\n  font-size: 0.875rem;\n  cursor: pointer;\n  padding: 2px 10px;\n  margin-right: 10px;\n  margin-top: -26px;\n  ", "\n  transition:  margin-top 550ms ease-in-out;\n  -webkit-mask-image: linear-gradient(180deg, transparent 1px, white 7px);\n  ", "\n\n  ", ";\n\n  ", "\n"])), function (props) {
  return props.expanded && styled.css(_templateObject46 || (_templateObject46 = defaultTheme._taggedTemplateLiteral(["\n      margin-top: 0px;\n    "])));
}, function (props) {
  return props.theme.themeProp('background', props.theme.getColor('gray-900'), props.theme.getColor('white'));
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('emerald-500'));
}, function (props) {
  return props.type === 'error' && styled.css(_templateObject47 || (_templateObject47 = defaultTheme._taggedTemplateLiteral(["\n      content: 'error';\n      ", "\n    "])), props.theme.themeProp('color', props.theme.getColor('red-200'), props.theme.getColor('red-500')));
});

var TextArea = React__default['default'].forwardRef(function TextArea(_ref, forwardedRef) {
  var value = _ref.value,
      defaultValue = _ref.defaultValue,
      name = _ref.name,
      label = _ref.label,
      placeholder = _ref.placeholder,
      required = _ref.required,
      disabled = _ref.disabled,
      hidden = _ref.hidden,
      readOnly = _ref.readOnly,
      edit = _ref.edit,
      autoComplete = _ref.autoComplete,
      description = _ref.description,
      type = _ref.type,
      icon = _ref.icon,
      rows = _ref.rows,
      className = _ref.className,
      style = _ref.style,
      _onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      lightBackground = _ref.lightBackground,
      noBorder = _ref.noBorder,
      instructionsTextArea = _ref.instructionsTextArea,
      loadingIcon = _ref.loadingIcon,
      successIcon = _ref.successIcon,
      padding = _ref.padding,
      descriptionToolTip = _ref.descriptionToolTip,
      borderRadius = _ref.borderRadius,
      fieldLabel = _ref.fieldLabel,
      rest = defaultTheme._objectWithoutProperties(_ref, ["value", "defaultValue", "name", "label", "placeholder", "required", "disabled", "hidden", "readOnly", "edit", "autoComplete", "description", "type", "icon", "rows", "className", "style", "onChange", "onBlur", "lightBackground", "noBorder", "instructionsTextArea", "loadingIcon", "successIcon", "padding", "descriptionToolTip", "borderRadius", "fieldLabel"]);

  var textInputDomNode = React.useRef(null);
  var textInputRef = useMergedRefs.useMergedRefs(forwardedRef, textInputDomNode);

  var _useState = React.useState(!(value || defaultValue)),
      _useState2 = defaultTheme._slicedToArray(_useState, 2),
      inputIsEmpty = _useState2[0],
      setInputIsEmpty = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = defaultTheme._slicedToArray(_useState3, 2),
      autoFocus = _useState4[0],
      setAutoFocus = _useState4[1];

  var _useState5 = React.useState(nanoid.nanoid()),
      _useState6 = defaultTheme._slicedToArray(_useState5, 1),
      uniqueId = _useState6[0];

  var memoizedDescriptionToolTip = React.useMemo(function () {
    return descriptionToolTip;
  }, [descriptionToolTip]);
  React.useEffect(function () {
    setAutoFocus(false);
  }, [value, defaultValue]);
  var onKeyDown = React.useCallback(function (event) {
    if (event.key === 'Enter') {
      event.stopPropagation();
    }
  }, []);

  var input = function input() {
    return React__default['default'].createElement(TextAreaContainter, null, fieldLabel && React__default['default'].createElement(Label, {
      htmlFor: uniqueId,
      disabled: disabled
    }, fieldLabel, React__default['default'].createElement(SuccessContainerLabel, null, type === 'loading' && loadingIcon, type === 'success' && successIcon)), React__default['default'].createElement(TextInput, {
      $fieldLabel: !lodash.isEmpty(fieldLabel),
      disabled: disabled,
      readOnly: readOnly,
      type: type,
      className: className,
      style: style
    }, React__default['default'].createElement(TextInputFieldIconAlert, {
      type: type
    }, icon), React__default['default'].createElement(TextInputField, defaultTheme._extends({
      autoFocus: autoFocus,
      borderRadius: borderRadius,
      ref: textInputRef,
      rows: rows,
      value: value,
      defaultValue: defaultValue,
      name: name,
      placeholder: placeholder || ' ',
      required: required,
      readOnly: readOnly,
      disabled: disabled,
      edit: edit,
      instructionsTextArea: instructionsTextArea,
      type: type,
      autoComplete: autoComplete,
      hasIcon: Boolean(icon),
      icon: icon,
      id: "text-input-".concat(uniqueId),
      key: uniqueId,
      lightBackground: lightBackground,
      padding: padding,
      onChange: function onChange(e) {
        if (e.target.value) {
          setInputIsEmpty(false);

          if (!autoFocus) {
            setAutoFocus(true);
          }
        } else {
          setInputIsEmpty(true);

          if (!autoFocus) {
            setAutoFocus(true);
          }
        }

        _onChange(e);
      },
      onKeyDown: onKeyDown,
      onBlur: onBlur,
      noBorder: noBorder
    }, rest)), !fieldLabel && (type === 'loading' || type === 'success') && React__default['default'].createElement(SuccessContainer, null, type === 'loading' && loadingIcon, type === 'success' && successIcon), !readOnly && noBorder && React__default['default'].createElement(InputIconContainer, {
      disabled: disabled
    }, React__default['default'].createElement(editNote.SvgEditNote, {
      className: padding === 'small' ? 'smallPadingIcon' : undefined
    })), label && React__default['default'].createElement(TextInputLabel, {
      htmlFor: "text-input-".concat(uniqueId),
      hasPlaceholder: Boolean(placeholder),
      hasIcon: Boolean(icon),
      inputIsEmpty: inputIsEmpty
    }, label, required && ' *'), typeof description === 'string' && description.length > 0 && React__default['default'].createElement(Description, {
      type: type
    }, description)));
  };

  if (hidden) return null;
  return React__default['default'].createElement(React__default['default'].Fragment, null, !memoizedDescriptionToolTip && input(), memoizedDescriptionToolTip && React__default['default'].createElement("div", null, React__default['default'].createElement(Tooltip.Tooltip, {
    content: memoizedDescriptionToolTip,
    key: "tooltipTextArea1",
    placement: "bottom-end",
    trigger: 'mouseenter',
    zIndex: 999999
  }, input())));
});
TextArea.defaultProps = {
  rows: 4,
  noBorder: false,
  readOnly: false,
  edit: false,
  hidden: false,
  type: '',
  padding: 'medium',
  instructionsTextArea: false,
  descriptionToolTip: '',
  isExpanded: function isExpanded() {},
  onChange: function onChange() {},
  borderRadius: 0
};
TextArea.propTypes = process.env.NODE_ENV !== "production" ? {
  value: defaultTheme.PropTypes.string,
  defaultValue: defaultTheme.PropTypes.string,
  name: defaultTheme.PropTypes.string,
  label: defaultTheme.PropTypes.string,
  fieldLabel: defaultTheme.PropTypes.string,
  placeholder: defaultTheme.PropTypes.string,
  required: defaultTheme.PropTypes.bool,
  disabled: defaultTheme.PropTypes.bool,
  hidden: defaultTheme.PropTypes.bool,
  readOnly: defaultTheme.PropTypes.bool,
  edit: defaultTheme.PropTypes.bool,
  autoComplete: defaultTheme.PropTypes.string,
  description: defaultTheme.PropTypes.string,
  error: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.bool, defaultTheme.PropTypes.string]),
  warning: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.bool, defaultTheme.PropTypes.string]),
  icon: defaultTheme.PropTypes.element,
  rows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),
  className: defaultTheme.PropTypes.string,
  style: defaultTheme.PropTypes.object,
  padding: defaultTheme.PropTypes.oneOf(['small', 'medium', 'large']),
  lightBackground: defaultTheme.PropTypes.bool,
  onChange: defaultTheme.PropTypes.func,
  onBlur: defaultTheme.PropTypes.func,
  noBorder: defaultTheme.PropTypes.bool,
  isExpanded: defaultTheme.PropTypes.func,
  type: defaultTheme.PropTypes.oneOf(['', 'error', 'error-border', 'warning-border', 'warning', 'loading', 'success']),
  instructionsTextArea: defaultTheme.PropTypes.bool,
  loadingIcon: defaultTheme.PropTypes.element,
  successIcon: defaultTheme.PropTypes.element,
  descriptionToolTip: defaultTheme.PropTypes.string,
  borderRadius: defaultTheme.PropTypes.number
} : {};

exports.TextArea = TextArea;
